import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import { queryClient } from "@/lib/queryClient";
import { deleteSingleRiskAnalysis } from "@/api/endpoints/riskAnalysis";
import type {
  DeleteSingleRiskAnalysisRequest,
  DeleteSingleRiskAnalysisResponse,
} from "@/api/types/riskAnalysis";

export function useDeleteSingleRiskAnalysis(): UseMutationResult<
  DeleteSingleRiskAnalysisResponse,
  Error,
  DeleteSingleRiskAnalysisRequest,
  unknown
> {
  return useMutation({
    mutationFn: deleteSingleRiskAnalysis,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["riskAnalysis"],
      });
    },
  });
}
